import { Fragment } from 'react';

function AboutSection() {
  return (<Fragment>
    <div
      className={`md:py-20 py-16 lg:w-9/12 w-full mx-auto text-textColor md:flex justify-between`}
    >
      <div className='md:w-4/12 w-8/12 justify-center mx-auto my-auto'>
        <img
          src='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/About%20us%20page-cuate.svg?alt=media&token=1a923210-ccef-4ed4-940f-c45a593b5166'
          alt='img'
        />
      </div>

      <div className='md:w-6/12 w-full p-6 my-auto'>
        <div>
          <h1
            className={`bg-amber border text-center rounded-2xl font-bold text-lg md:w-4/12 w-4/12 p-2`}
          >
            من نحن
          </h1>
        </div>

        <h5
          className={`mb-2 mt-4 md:text-4xl text-xl font-bold tracking-tight text-gray700`}
        >
          نحن نعمل على زيادة نجاح الأعمال بإستخدام التكنولوجيا
        </h5>
        <p className={`mb-3 mt-4 font-normal text-gray500`}>
          Ge Step شركة متخصصة في مجال التسويق الإلكتروني وتهدف إلى زيادة مبيعات العملاء وزيادة الوعي بالعلامة التجارية الخاصة بهم وإعداد خطط تسويقية بهدف زيادة حصة الشركة في السوق وتقليل خسائر العملاء كما وتعمل الشركة على إدارة صفحات السوشيال ميديا على جميع المنصات وإنشاء حملات إعلانية وكتابة محتوى وإعداد التصماميم اللازمة وإدارة المتاجر الإلكترونية
        </p>

        <div>
          <h1
            className={`bg-amber border text-center rounded-2xl font-bold text-lg md:w-4/12 w-4/12 p-2`}
          >
            أسعار الخدمات
          </h1>
        </div>

        <h5
          className={`mb-2 mt-4 md:text-4xl text-xl font-bold tracking-tight text-gray700`}
        >
          نقدم أسعار تنافسية للخدمات تناسب الميزانيات المبتدئة والمتوسطة والكبيرة
        </h5>
        <p className={`mb-3 mt-4 font-normal text-gray500`}>
          فجميع الخدمات تضمن تلبية احتياجات الجمهور المستهدف، وتحقيق الأهداف التسويقية للشركات.
          وتختلف أسعار خدمات التسويق الإلكتروني لدينا حسب متطلبات كل مشروع حيث نراعي تقديم أفضل خدمة بسعر ممتاز.

        </p>
      </div>
    </div>


  </Fragment>
  );
}

export default AboutSection;
